/**
 * 車輌異動履歴一覧 型定義
 */
export type TSyaryoIdoRirekiTable = {
  車輌所属リスト: TSyaryoIdoRireki[]
}

export type TSyaryoIdoRireki = {
  車輌所属ID: number
  車輌ID?: number
  所属開始日: string
  所属終了日: string
  所属部所コード: string
  所属部所名: string
  車番: string
  登録番号地域: string
  登録番号分類: string
  登録番号記号: string
  登録番号指定番号: string
  異動時登録番号: string
  表示順: number
  備考: string
  乗務員ID: number
  担当乗務員コード: string
  担当乗務員名: string
  部所ID: number
  会社コード: string
  会社名: string
  会社略称: string
  削除フラグ: number
  更新日時?: string
}

/**
 * 車輌異動履歴一覧 初期値
 */
export const initialSyaryoIdoRirekiTableState: TSyaryoIdoRirekiTable = {
  車輌所属リスト: [],
}
